import { render, staticRenderFns } from "./BolSaveButton.vue?vue&type=template&id=0cb34030&scoped=true"
import script from "./BolSaveButton.vue?vue&type=script&lang=js"
export * from "./BolSaveButton.vue?vue&type=script&lang=js"
import style0 from "./BolSaveButton.vue?vue&type=style&index=0&id=0cb34030&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb34030",
  null
  
)

export default component.exports